// services/registerUser.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const registerUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.register}`;
const registerUser = async ({ userData, lang }) => {
  try {
    const response = await axios.post(registerUrl, userData, {
      headers: {
        lang: lang,
      },
    });
    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error registering user:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

export default registerUser;
